import { render } from "./CodeData.vue?vue&type=template&id=584e8549&style=display%3A%20inline-block"
import script from "./CodeData.vue?vue&type=script&lang=js"
export * from "./CodeData.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__